import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './berserk_axe.png'

export const berserk_axe: ItemUI<Weapon> = {
    image,
    label: 'Berserk axe',
    value: 150,
    item: {
        key: 'berserk_axe',
        type: 'weapon',
        rarity: ItemRarity.Legendary,
        stats: {
            strength: 30,
            agility: -20
        },
        two_handed: true,
        category: 'axe',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 5,
        damage: 20
    }
}
